<template>
  <!-- 
  <div>
    <Row :gutter="30" style="margin-bottom:25px;">
      <Col span="6" :lg="6" :md="6" :sm="12" :xs="24">
      <div class="card">
        <div class="card-body">
          <div class="card-body-left" :style="{background:'#2d8cf0'}">
            <i class="ivu-icon i-icon icon-kuaidiyuan" style="font-size: 32px;"></i>
          </div>
          <div class="card-body-right">
            <h3>{{couriersCount}}</h3>
            <p>快递员数量</p>
          </div>
        </div>
      </div>
      </Col>
      <Col span="6" :lg="6" :md="6" :sm="12" :xs="24">
      <div class="card">
        <div class="card-body">
          <div class="card-body-left" :style="{background:'#19be6b'}">
            <i class="ivu-icon i-icon icon-car" style="font-size: 32px;"></i>
          </div>
          <div class="card-body-right">
            <h3>{{carsCount}}</h3>
            <p>运行快递车数量</p>
          </div>
        </div>
      </div>
      </Col>
      <Col span="6" :lg="6" :md="6" :sm="12" :xs="24">
      <div class="card">
        <div class="card-body">
          <div class="card-body-left" :style="{background:'#ff9900'}">
            <i class="ivu-icon i-icon icon-company" style="font-size: 32px;"></i>
          </div>
          <div class="card-body-right">
            <h3>{{companiesCount}}</h3>
            <p>下属企业数量</p>
          </div>
        </div>
      </div>
      </Col>
      <Col span="6" :lg="6" :md="6" :sm="12" :xs="24">
      <div class="card">
        <div class="card-body">
          <div class="card-body-left" :style="{background:'#E46CBB'}">
            <i class="ivu-icon i-icon icon-kuaidiyuan" style="font-size: 32px;"></i>
          </div>
          <div class="card-body-right">
            <h3>{{couriersCount}}</h3>
            <p>快递员数量</p>
          </div>
        </div>
      </div>
      </Col>
    </Row>
    <Row :gutter="30">
      <Col span="12" :lg="12" :md="12" :sm="24" :xs="24">
      <div class="card">
        <div class="card-head">车辆地图</div>
        <div class="card-body">
          <car-map :lite-mode="true" :visible-empty-area="false" style="height:400px;" />
        </div>
      </div>
      </Col>
      <Col span="12" :lg="12" :md="12" :sm="24" :xs="24">
      <div class="card">
        <div class="card-head">公司地图</div>
        <div class="card-body">
          <company-map style="height:400px;" />
        </div>
      </div>
      </Col>
    </Row>
  </div>-->
  <car-map :auto-update="false" style="position: absolute;height:100%;" />
  <!-- <car-map :lite-mode="true" :switchZoom="switchZoom" :visible-empty-area="false" style="position: absolute;height:100%;" /> -->

</template>
<script>
import carMap from '../car/info/map'
import companyMap from '../company/info/map'
export default {
  components: { carMap, companyMap },
  data() {
    return {
      companiesCount: 0,
      carsCount: 0,
      couriersCount: 0,
    }
  },
  created() {

  }
}

</script>
<style lang='scss'>
.card {
  background: #fff;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .1);

  .ic {
    color: #fff;
  }

  .card-head {
    height: 54px;
    line-height: 54px;
    margin-bottom: -1px;
    padding: 0 24px;
    color: rgba(0, 0, 0, .85);
    font-weight: 500;
    font-size: 16px;
    background: transparent;
    border-bottom: 1px solid #e8e8e8;
    border-radius: 2px 2px 0 0;
  }

  .card-body {
    display: flex;
    // height: 100%;

    .card-body-left {
      flex: 1 1 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      height:120px;
    }

    .card-body-right {
      flex: 1 1 68%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 0 12px;

      h3 {
        color: rgba(0, 0, 0, .85);
        font-size: 30px;
        font-weight: 500;
      }

      p {
        color: rgba(0, 0, 0, .45);
        font-size: 14px;
      }
    }
  }
}

</style>
